import React from 'react';
import { Form } from 'react-bootstrap';
import style from './Common.module.scss';
import { useTranslation } from 'react-i18next';

function FormSelectControl({ label, isRequired, error, options, selectProp }) {
  const { t } = useTranslation();

  return (
    <Form.Group className={`${style.formGroup} ${selectProp.formClass}`}>
      {label && (
        <Form.Label
          className={isRequired && style.required}
          {...selectProp.labelProps}
        >
          {label}
        </Form.Label>
      )}
      <Form.Control
        as="select"
        className={`
          ${selectProp.selectClass}
          ${error && error.error ? `${style.FormsHasError} form-control is-invalid` : ""}
        `}
        disabled={selectProp.disabled}
        {...selectProp}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {t(option.label)}
          </option>
        ))}
      </Form.Control>
      <Form.Text
        className={`
          ${error && error.error ? style.isInvalid : "d-none"}
        `}
      >
        {error && t(error.error)}
      </Form.Text>
    </Form.Group>
  );
}

export default FormSelectControl;
